// extracted by mini-css-extract-plugin
export default {"cls1":"TruncateHeight-cls1_JbS","cls2":"TruncateHeight-cls2_iP7 TruncateHeight-cls1_JbS"};